import { render, staticRenderFns } from "./ApartmentCustomer.vue?vue&type=template&id=167a46a4&scoped=true&"
import script from "./ApartmentCustomer.vue?vue&type=script&lang=ts&"
export * from "./ApartmentCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./ApartmentCustomer.vue?vue&type=style&index=0&id=167a46a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167a46a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('167a46a4')) {
      api.createRecord('167a46a4', component.options)
    } else {
      api.reload('167a46a4', component.options)
    }
    module.hot.accept("./ApartmentCustomer.vue?vue&type=template&id=167a46a4&scoped=true&", function () {
      api.rerender('167a46a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apartment/components/ApartmentCustomer.vue"
export default component.exports